export default "__VITE_ASSET__3527803c__"